import { useQuery } from 'react-query';
import { Deal } from '@jucy/rentals-api-client';
import { useRouter } from 'next/router';

export type StarRvDeal = Deal & {
    showInBanner?: boolean;
};

async function fetchStarRvDeals(locale?: string): Promise<StarRvDeal[]> {
    const response = await fetch(
        `${process.env.NEXT_PUBLIC_RENTALS_API_URL ?? 'https://rentals.api.jucy.cloud'}/api/deals?accountId=6F377E6F-9786-E611-80E8-C4346BC5C274&tags=motorhome&region=${locale}`
    );
    const data: { items: StarRvDeal[] } = await response.json();
    return data.items;
}

export const useStarRvDeals = () => {
    const { locale } = useRouter();
    return useQuery(['star-rv-deals', locale], () => fetchStarRvDeals(locale), { staleTime: Infinity });
};
